const configBoardFilter = {
  notice: {
    getFunc: "getNotice",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      type: "post",
      la: 1,
      cid: 30,
    },
    pageRow: 10,
    deleteFunc: "deleteNotice",
    deleteApiParamsSet: {
      type: "post",
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteErrorTypes: {},
    keyName: "wr_id",
    detailKey: "",
  },
  noticeCreate: {
    writeFunc: "createNotice",
    writeApiParamSet: {
      language: "create",
      type: "post",
      wr_type: "post",
    },
    parsingData: {
      title: "wr_subject",
      content: "wr_content",
      langOption: "c_idx",
    },
    fileType: "",
    directUrl: "",
    directType: "back",
    keyName: "id",
    writeSuccessType: 1,
    writeFailTypes: {},
  },
  noticeUpdate: {
    getFunc: "getNotice",
    detailApiParamsSet: {
      ip: 0,
      type: "post",
      la: 1,
    },
    writeFunc: "updateNotice",
    writeApiParamSet: {
      language: "update",
      type: "post",
      wr_type: "post",
    },
    parsingData: {
      title: "wr_subject",
      content: "wr_content",
    },
    fileType: "",
    directUrl: "",
    directType: "back",
    keyName: "id",
    writeSuccessType: 1,
    writeFailTypes: {
      '-377':"해당 글과 연결된 팝업이 있어서 수정 불가합니다."
    },
  },
  faq: {
    getFunc: "getFaq",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      type: "post",
      la: 1,
      cid: 30,
    },
    pageRow: 10,
    deleteFunc: "deleteFaq",
    deleteApiParamsSet: {
      type: "post",
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteErrorTypes: {},
    keyName: "wr_id",
  },
  faqCreate: {
    getFunc: "",
    detailApiParamsSet: {},
    writeFunc: "createFaq",
    writeApiParamSet: {
      language: "create",
      type: "post",
      wr_type: "post",
    },
    parsingData: {
      title: "wr_subject",
      content: "wr_content",
      langOption: "c_idx",
    },
    directUrl: "",
    directType: "back",
    keyName: "id",
    writeSuccessType: 1,
    writeFailTypes: {},
  },
  faqUpdate: {
    getFunc: "getFaq",
    detailApiParamsSet: {
      ip: 0,
      type: "post",
      la: 1,
    },
    writeFunc: "updateFaq",
    writeApiParamSet: {
      type: "post",
    },
    parsingData: {
      title: "wr_subject",
      content: "wr_content",
    },
    directUrl: "",
    directType: "back",
    keyName: "id",
    writeSuccessType: 1,
    writeFailTypes: {},
  },
  qna: {
    getFunc: "getQna",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      type: "post",
      la: 1,
      cmt: 1,
      wr: 1,
    },
    pageRow: 10,
    deleteFunc: "",
    deleteApiParamsSet: {},
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteErrorTypes: {},
    keyName: "wr_id",
  },
  qnaCreate: {
    getFunc: "getQna",
    detailApiParamsSet: {
      ip: 0,
      f: 1,
      type: "post",
      la: 1,
      cmt: 1,
      wr: 1,
    },
    writeFunc: "createQna",
    writeApiParamSet: {
      wr_type: "comment",
      type: "post",
    },
    parsingData: {
      title: "wr_subject",
      content: "wr_content",
      wid: "wr_id",
      wp_id: "wr_parent",
    },
    directUrl: "",
    directType: "back",
    keyName: "id",
    writeSuccessType: 1,
    writeFailTypes: { " -520,": "삭제된 문의입니다." },
    fileType: "qna_admin",
  },
  qnaUpdate: {
    getFunc: "getQna",
    detailApiParamsSet: {
      ip: 0,
      f: 1,
      type: "post",
      la: 1,
      cmt: 1,
      wr: 1,
    },
    writeFunc: "updateQna",
    writeApiParamSet: {
      wr_type: "comment",
      type: "post",
    },
    parsingData: {
      title: "wr_subject",
      content: "wr_content",
      wid: "wr_id",
      wp_id: "wr_parent",
    },
    directUrl: "",
    directType: "back",
    keyName: "id",
    writeSuccessType: 1,
    writeFailTypes: {},
    fileType: "qna_admin",
  },
  event: {
    getFunc: "getEvent",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      la: 1,
      type: "post",
      cid: 30,
    },
    pageRow: 10,
    deleteFunc: "deleteEvent",
    deleteApiParamsSet: {
      type: "post",
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteErrorTypes: {},
    keyName: "wr_id",
  },
  eventCreate: {
    getFunc: "",
    detailApiParamsSet: {},
    writeFunc: "createEvent",
    writeApiParamSet: {
      wr_type: "post",
      type: "post",
      language: "create",
      event: "create",
    },
    parsingData: {
      title: "wr_subject",
      content: "wr_content",
      langOption: "c_idx",
      be_start: "be_start",
      be_end: "be_end",
        moveRoute: 'be_link',
        moveRouteKey: 'be_link_key',
    },
    directUrl: "",
    directType: "back",
    keyName: "wid",
    writeSuccessType: 1,
    writeFailTypes: {},
    fileType: "",
  },
  eventUpdate: {
    getFunc: "getEvent",
    detailApiParamsSet: {
      ip: 0,
      la: 1,
      type: "post",
    },
    writeFunc: "updateEvent",
    writeApiParamSet: {
      wr_type: "post",
      type: "post",
      language: "update",
      event: "update",
    },
    parsingData: {
      title: "wr_subject",
      content: "wr_content",
      langOption: "c_idx",
      be_start: "be_start",
      be_end: "be_end",
        moveRoute: 'be_link',
        moveRouteKey: 'be_link_key',
    },
    directUrl: "",
    directType: "back",
    keyName: "wid",
    writeSuccessType: 1,
    writeFailTypes: {},
    fileType: "",
  },
  userContent: {
    getFunc: "getUserContent",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      type: "post",
      wr: 1,
      use: 1,
      mbuse: 1,
    },
    pageRow: 10,
    deleteFunc: "deleteUserContent",
    deleteApiParamsSet: {},
    deleteSuccessType: 1,
    deleteFailTypes: {},
    keyName: "wr_id",
  },
  userContentDetail: {
    getFunc: "getUserContent",
    detailApiParamSet: {
      ip: 0,
      type: "post",
      wr: 1,
      f: 1,
      ctn : 1
    },

    deleteFunc: "deleteUserContent",
    deleteApiParamsSet: {
      type: "post",
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    keyName: "wr_id",
    contentType : 'content'
  },
  userContentCommentList: {
    getFunc: "getUserContentComment",
    listApiParamSet: {
      ip: 1,
      type: "comment",
      cwr: 1,
      cmt:1
    },

    deleteFunc: "deleteUserContentComment",
    deleteApiParamsSet: {
      wr_parent: 0,
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},

    keyName: "wr_id",
  },
  ktalkContent: {
    getFunc: "getKtalkContent",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      type: "post",
      wr: 1,
      use: 1,
      mbuse: 1,
    },
    pageRow: 10,
    deleteFunc: "deleteKtalkContent",
    deleteApiParamsSet: {},
    deleteSuccessType: 1,
    deleteFailTypes: {},
    keyName: "wr_id",
  },
  ktalkContentDetail: {
    getFunc: "getKtalkContent",
    detailApiParamSet: {
      ip: 0,
      type: "post",
      wr: 1,
      f: 1,
    },

    deleteFunc: "deleteKtalkContent",
    deleteApiParamsSet: {
      type: "post",
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    keyName: "wr_id",
    contentType:"koreantalk"
  },
  ktalkContentCommentList: {
    getFunc: "getKtalkContentComment",
    listApiParamSet: {
      ip: 1,
      type: "comment",
      cwr: 1,
      cmt:1
    },

    deleteFunc: "deleteKtalkContentComment",
    deleteApiParamsSet: {
      wr_parent: 0,
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},

    keyName: "wr_id",
  },
  userCommentReplyList: {
    deleteFunc: "deleteUserContentComment",
    deleteApiParamsSet: {
      wr_parent: 0,
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},

    keyName: "wr_id",
  },
  ktalkCommentReplyList: {
    deleteFunc: "deleteKtalkContentComment",
    deleteApiParamsSet: {
      wr_parent: 0,
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},

    keyName: "wr_id",
  },
  mail: {
    getFunc: "getMail",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
    },
    pageRow: 10,
    deleteFunc: "",
    deleteApiParamsSet: {},
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteErrorTypes: {},
    keyName: "",
  },
  mailSend: {
    getFunc: "",
    detailApiParamsSet: {},
    writeFunc: "sendMail",
    writeApiParamSet: {},
    parsingData: {
      type: "type",
      title: "title",
      content: "content",
      langOption: "ms_language",
    },
    directUrl: "",
    directType: "back",
    keyName: "",
    writeSuccessType: 1,
    writeFailTypes: { " -1,": "보낼 회원이 없습니다." },
    fileType: "",
  },
  mailDetail: {
    getFunc: "getMail",
    detailApiParamsSet: {},
    writeFunc: "",
    writeApiParamSet: {},
    parsingData: {},
    directUrl: "",
    directType: "back",
    keyName: "id",
    writeSuccessType: 1,
    writeFailTypes: {},
    fileType: "",
  },
  userContentSelect: {
    getFunc: "getUserContent",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      type: "post",
      wr: 1,
    },
    pageRow: 10,
    deleteFunc: "deleteUserContent",
    deleteApiParamsSet: {},
    deleteSuccessType: 1,
    deleteFailTypes: {},
    keyName: "wr_id",
  },
  noticeSelect: {
    getFunc: "getNotice",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      type: "post",
      la: 1,
      cid: 30,
    },
    pageRow: 10,
    deleteFunc: "deleteNotice",
    deleteApiParamsSet: {
      type: "post",
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteErrorTypes: {},
    keyName: "wr_id",
    detailKey: "",
  },
  productSelect: {
    getFunc: "getProduct",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      use:1,
    },
    pageRow: 10,
    // deleteFunc: "deleteNotice",
    // deleteApiParamsSet: {
    //   type: "post",
    // },
    // deleteSuccessType: 1,
    // deleteFailTypes: {},
    // deleteErrorTypes: {},
    // keyName: "wr_id",
    // detailKey: "",
  },
  eventSelect: {
    getFunc: "getEvent",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      la: 1,
      type: "post",
      cid: 30,
      oed: "now",
    },
    pageRow: 10,
    deleteFunc: "deleteEvent",
    deleteApiParamsSet: {
      type: "post",
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteErrorTypes: {},
    keyName: "wr_id",
  },

  ssamsContent: {
    getFunc: "getSsamsContent",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      type: "post",
      wr: 1,
    },
    pageRow: 10,
    keyName: "s_idx",
  },
  ssamsContentDetail: {
    getFunc: "getSsamsContent",
    detailApiParamSet: {
      type: "post",
      wr_type: "post",
      ip: 0,
      f: 1,
      wr: 1,
      obt: "wr.created_at",
      obs: "desc",
    },
    getSuccessType: 1,
    getErrorTypes: {},
    detailKeyName: "wr_id",
    keyName: "wr_id",
    isGetMyInfo: true,
    deleteFunc: "deleteSsamsContent",
    deleteApiParamSet: { type: "post" },
    deleteSuccessType: 1,
    deleteErrorTypes: {},
  },
  ssamsContentCommentList: {
    getFunc: "getSsamsContentComment",
    listApiParamSet: {
      ip: 1,
      type: "comment",
      cwr: 1,
      cmt:1
    },
    deleteFunc: "deleteSsamsContentComment",
    deleteApiParamsSet: {
      wr_parent: 0,
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    keyName: "wr_id",
  },

  ssamsKoreanTalk: {
    getFunc: "getSsamsKoreanTalk",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      type: "post",
      wr: 1,
    },
    pageRow: 10,
    keyName: "s_idx",
  },
  ssamsKoreanTalkDetail: {
    getFunc: "getSsamsKoreanTalk",
    detailApiParamSet: {
      ip: 0,
      type: "post",
      wr: 1,
      f: 1,
    },
    deleteFunc: "deleteSsamsKoreanTalk",
    deleteApiParamsSet: {
      type: "post",
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    keyName: "wr_id",
  },
  ssamsKoreanTalkCommentList: {
    getFunc: "getSsamsKoreanTalkComment",
    listApiParamSet: {
      ip: 1,
      type: "comment",
      cwr: 1,
      cmt:1
    },
    deleteFunc: "deleteSsamsKoreanTalkComment",
    deleteApiParamsSet: {
      wr_parent: 0,
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    keyName: "wr_id",
  },
  ssamsFix: {
    getFunc: "getSsamsFix",
    parsingData: {
      wid: "wr_id",
      sid: "s_idx",
    },
    deleteFunc: "deleteNotice",
    paginationType: "pagination",
    listApiParamSet: {
    },
    deleteApiParamsSet: {
      type: "post",
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteErrorTypes: {},
    keyName: "s_idx",
  },
  ssamsContentFix: {
    getFunc: "getSsamsContent",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      type: "post",
      wr: 1,
    },
    pageRow: 10,
    keyName: "s_idx",
  },
  ssamsKoreanTalkFix: {
    getFunc: "getSsamsKoreanTalk",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      type: "post",
      wr: 1,
    },
    pageRow: 10,
    keyName: "s_idx",
  },
  contentFix : {
    getFunc: "getContentFix",
    writeFunc : "createContentFix",
    parsingData: {
      wid: "wr_id",
      // sid: "s_idx",
    },
    deleteFunc: "deleteNotice",
    paginationType: "pagination",
    listApiParamSet: {
    },
    deleteApiParamsSet: {
      type: "post",
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteErrorTypes: {},
    keyName: "s_idx",
    // modal : 'contentFixModal'
  },
  ktalkFix : {
    getFunc: "getKoreanTalkFix",
    writeFunc : "createKoreantalkFix",
    parsingData: {
      wid: "wr_id",
      // sid: "s_idx",
    },
    deleteFunc: "deleteNotice",
    paginationType: "pagination",
    listApiParamSet: {
    },
    deleteApiParamsSet: {
      type: "post",
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteErrorTypes: {},
    keyName: "s_idx",
    // modal : 'ktalkFixModal'
  },
  ktalkFixModal : {
    getFunc: "getKtalkContent",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      type: "post",
      wr: 1,
      use: 1,
      mbuse: 1,
    },
    pageRow: 10,
    keyName: "wr_id",
  },
  contentFixModal : {
    getFunc: "getUserContent",
    paginationType: "pagination",
    listApiParamSet: {
      ip: 1,
      type: "post",
      wr: 1,
    },
    pageRow: 10,
    deleteFunc: "deleteUserContent",
    deleteApiParamsSet: {},
    deleteSuccessType: 1,
    deleteFailTypes: {},
    keyName: "wr_id",
  },
  contentCreateFix : {
    getFunc: "getContentFix",
    writeFunc : "createContentFix",
    parsingData: {
      wid: "wr_id",
    },
    deleteFunc: "deleteContentFix",
    paginationType: "pagination",
    listApiParamSet: {
    },
    deleteApiParamsSet: {
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteErrorTypes: {},
    keyName: "bn_idx",
    writeSuccessType: 1,
    directUrl: "",
    directType: "back",
  },
  contentUpdateFix : {
    getFunc: "getContentFix",
    writeFunc : "updateContentFix",
    parsingData: {
      wid: "wr_id",
      bid: "bn_idx"
    },
    deleteFunc: "deleteContentFix",
    paginationType: "pagination",
    listApiParamSet: {
    },
    deleteApiParamsSet: {
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteErrorTypes: {},
    keyName: "bn_idx",
    writeApiParamSet: {
      bn_idx : 'bn_idx',
      wr_id : 'wr_id',
    },
    writeSuccessType: 1,
    directUrl: "",
    directType: "back",

  },
  ktalkCreateFix : {
    getFunc: "getContentFix",
    writeFunc : "createKoreantalkFix",
    parsingData: {
      wid: "wr_id",
    },
    deleteFunc: "deleteKoreantalkFix",
    paginationType: "pagination",
    listApiParamSet: {
    },
    deleteApiParamsSet: {
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteErrorTypes: {},
    keyName: "bn_idx",
    writeSuccessType: 1,
    directUrl: "",
    directType: "back",
  },
  ktalkUpdateFix : {
    getFunc: "getContentFix",
    writeFunc : "updateKoreantalkFix",
    parsingData: {
      wid: "wr_id",
      bid : "bn_idx"
    },
    deleteFunc: "deleteKoreantalkFix",
    paginationType: "pagination",
    listApiParamSet: {
    },
    deleteApiParamsSet: {
    },
    deleteSuccessType: 1,
    deleteFailTypes: {},
    deleteErrorTypes: {},
    keyName: "bn_idx",
    writeApiParamSet: {
      bn_idx : 'bn_idx',
      wr_id : 'wr_id',
    },
    writeSuccessType: 1,
    directUrl: "",
    directType: "back",
  },



};

export default {
    methods: {
        returnBoardFilterConfig(type) {
            return configBoardFilter[type];
        },

    },
    data(){
      return{
      }
    },
    filterConfig: {
        su: {
            type: 'query',
            classname: 'searchInput'
        },
        co: {
            type: 'query',
            classname: 'searchInput'
        },
        cid: {
            type: 'match',
            classname: 'langOption'
        },
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        mid:{
            type: 'query',
            classname: 'searchInput'
        },
        mbid:{ //1:1문의 작성자 아이디
            type: 'query',
            classname: 'searchInput'
        },
        ni:{
            type: 'query',
            classname: 'searchInput'
        },
        mbni:{ //유저콘텐츠, 1:1문의 작성자 닉네임
            type: 'query',
            classname: 'searchInput'
        },
        isa:{
            type: 'match',
            classname: 'qaStatus'
        },
        ti: {
            type: 'query',
            classname: 'searchInput'
        },
        bn: {
          type: 'query',
          classname: 'searchInput'
        },
        gn: {
          type: 'query',
          classname: 'searchInput'
        },
        pge : { //가격시작
          type : 'match',
          classname : 'filterPrice_prsd'
      },
      ple : { //가격 끝
          type : 'match',
          classname : 'filterPrice_pred'
      },
    }
}
